import { render, staticRenderFns } from "./PickupPointsViewer.vue?vue&type=template&id=fe71c4d0&scoped=true&"
import script from "./PickupPointsViewer.vue?vue&type=script&lang=js&"
export * from "./PickupPointsViewer.vue?vue&type=script&lang=js&"
import style0 from "./PickupPointsViewer.vue?vue&type=style&index=0&id=fe71c4d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe71c4d0",
  null
  
)

export default component.exports